import { SvgEnum } from "../../../../ui library/components/svgs/standard/svg";
import HNSColors from "../../../../ui library/HNSColors";

import GenericModal from "./GenericModal";

export default function DeleteModal({ additionalDetails = {} }) {
  return (
    <GenericModal
      iconName={SvgEnum.HisAlertCircle}
      iconColor={HNSColors.failure[500]}
      iconBgColor={HNSColors.failure[700]}
      title="Warning"
      titleColor={HNSColors.failure[500]}
      message="Are you sure you want to delete this item? This action can not be undone."
      buttons={[
        {
          label: "Cancel",
          onClick: additionalDetails.handleCancel,
          variant: "outlined",
          sx: {
            border: "1px solid",
            backgroundColor: HNSColors.neutrals[900],
            color: HNSColors.failure[500],
            borderColor: HNSColors.failure[500],
            "&:hover": {
              backgroundColor: HNSColors.failure[700],
              color: HNSColors.failure[900],
              borderColor: HNSColors.neutrals[900],
            },
          },
        },
        {
          label: additionalDetails.deleteLabel ?? "Delete",
          onClick: additionalDetails.handleDelete,
          disabled: additionalDetails.isDeleting ?? false,
          sx: {
            backgroundColor: HNSColors.failure[500],
            color: HNSColors.neutrals[900],
            "&:hover": {
              backgroundColor: HNSColors.failure[600],
              color: HNSColors.neutrals[900],
            },
          },
        },
      ]}
    />
  );
}
